<style scoped lang="scss">
</style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/dictItem/page" getKey="rows"
			:columns="columns" @expandChange="expandChange">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('zidianleixing')">
						<el-select filterable :clearable="true" v-model="yt.conditions.typeId">
							<el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zidianzhi')">
						<el-input v-model="yt.conditions.value"></el-input>
						<!-- <el-select filterable :clearable="true" v-model="yt.conditions.value">
							<el-option v-for="(item,index) in dictItemList" :key="index" :label="item.name" :value="item.value">
							</el-option>
						</el-select> -->
					</el-form-item>
					<el-form-item :label="$t('biaoqian')">
						<el-input v-model="yt.conditions.label"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain>
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/config/dictItem/delete')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 底部插槽 -->
			<template #footer>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('zidianleixing')" required>
						<el-select filterable :clearable="true" v-model="yt.editObj.typeId">
							<el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zidianzhi')" required>
						<el-input v-model="yt.editObj.value" maxlength="100"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shunxu')" required>
						<el-input v-model="yt.editObj.priority" maxlength="8"
							@input="yt.editObj.priority = String(yt.editObj.priority).replace(/[^\d]/g,'')"></el-input>
					</el-form-item>
					<el-form-item :label="$t('label')" required>
						<el-input v-model="yt.editObj.label" maxlength="100"></el-input>
					</el-form-item>
					<el-form-item :label="$t('guojihuabiaoqian-key')" required>
						<el-input v-model="yt.editObj.labelI18n" maxlength="400"></el-input>
					</el-form-item>
					<el-form-item :label="$t('color')">
						<el-input v-model="yt.editObj.color" maxlength="400"></el-input>
					</el-form-item>
					<el-form-item :label="$t('beijingyanse')">
						<el-input v-model="yt.editObj.backgroundColor" maxlength="400"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/config/dictItem/create')" type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('zidianleixing')" required>
						<el-select filterable :clearable="true" v-model="yt.editObj.typeId" disabled>
							<el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zidianzhi')" required>
						<el-input v-model="yt.editObj.value" disabled></el-input>
					</el-form-item>
					<el-form-item :label="$t('shunxu')" required>
						<el-input v-model="yt.editObj.priority" maxlength="8"
							@input="yt.editObj.priority = String(yt.editObj.priority).replace(/[^\d]/g,'')"></el-input>
					</el-form-item>
					<el-form-item :label="$t('label')" required>
						<el-input v-model="yt.editObj.label" maxlength="100"></el-input>
					</el-form-item>
					<el-form-item :label="$t('guojihuabiaoqian-key')" required>
						<el-input v-model="yt.editObj.labelI18n" maxlength="400"></el-input>
					</el-form-item>
					<el-form-item :label="$t('color')">
						<el-input v-model="yt.editObj.color" maxlength="400"></el-input>
					</el-form-item>
					<el-form-item :label="$t('beijingyanse')">
						<el-input v-model="yt.editObj.backgroundColor" maxlength="400"></el-input>
					</el-form-item>
				</el-form>
				<template slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/config/dictItem/update')" type="primary">{{$t('baocun')}}
					</el-button>
				</template>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'admin_global_dictionary_list',

		data() {
			return {
				loading: false, //是否显示加载动画
				dictionaryList: [], // 字典类型列表
				// dictItemList: [],
				list: [],
				columns: [{
						label: 'ID',
						prop: 'id',
						width: 100,

					},
					{
						label: 'zidianleixing',
						prop: 'typeName',
						width: 130,
					},
					{
						label: 'zidianzhi',
						prop: 'value'
					},
					{
						label: 'biaoqian',
						prop: 'label'
					},
					{
						label: 'guojihuabiaoqian-key',
						prop: 'labelI18n',
					},
					{
						label: 'color',
						prop: 'color',
					},
					{
						label: 'beijingyanse',
						prop: 'backgroundColor',
					},
					{
						label: 'shunxu',
						prop: 'priority',
					},
					{
						label: 'caozuo',
						type: 'slot',
						width: 130,
						fixed: 'right',
					},
				],
			};
		},
		computed: {},
		created() {
			// table列表接口请求参数
			setTimeout(() => {
				this.yt.get(1);
				this.getDictCatList();
				// this.getDictItemList();
			}, 300)


		},
		methods: {
			// async getDictItemList() {
			// 	let response = await this.http.get('/web/config/dictItem/page',{
			// 		params: {
			// 			pageNum: 1,
			// 			pageSize: 100
			// 		}
			// 	})
			// 	this.dictItemList = response.data.rows
			// },
			listChange() {

			},
			// 获取字典类型
			async getDictCatList() {
				let response = await this.http.get('/web/config/dictType/list', {
					params: {
						pageNum: 1,
						pageSize: 9999999
					}
				})
				this.dictionaryList = response.data
			}
		},
	};
</script>
